import React, { useMemo } from 'react';
import { SelectInput, Text } from '@ui';
import { translate } from '@utils/i18n';
import './TerritorySelectStyles.scss';
const NAMESPACE = 'features.modals.territory_select';
export function TerritorySelect({ options, restricted, values, onChange, disabled = false, error = undefined, lockedReason = undefined }) {
    const visibleValues = useMemo(() => values.filter((id) => options.some((option) => option.value === id)), [values, options]);
    const hiddenCount = values.length - visibleValues.length;
    const helpKey = restricted ? 'help_restricted' : 'help';
    return (React.createElement("div", { className: "territorySelect" },
        React.createElement(SelectInput, { id: "territoryIds", label: translate('territories', { namespace: NAMESPACE }), options: options, values: visibleValues, onMultiChange: onChange, multiple: true, showSearch: true, displayMode: "summary", disabled: disabled, error: error }),
        React.createElement(Text, { variant: "xx-small", as: "p", className: "territorySelect__help" }, lockedReason || translate(helpKey, { namespace: NAMESPACE })),
        hiddenCount > 0 && (React.createElement(Text, { variant: "xx-small", as: "p", className: "territorySelect__help" }, translate('hidden', { namespace: NAMESPACE, count: hiddenCount })))));
}
export default TerritorySelect;
